import { useEffect } from "react";
import sessionManager, { AUTH_NOTICE_KEY } from "../utils/sessionManager";
import { isAuthenticated, clearAuth } from "../utils/auth";

/**
 * Resumes session tracking after reload and clears stale expired tokens.
 */
export default function SessionBootstrap() {
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) return;

    if (isAuthenticated()) {
      sessionManager.init();
      return;
    }

    sessionStorage.setItem(
      AUTH_NOTICE_KEY,
      "auth.sessionExpired",
    );
    clearAuth();
  }, []);

  return null;
}
